import React, { useState } from 'react';
import { motion } from 'framer-motion';


/**
 * @title : 메인 정보 텍스트 값 입니다.
 * @pointText :  핵심 문구 텍스트 값 입니다.
 * @subtitle : 서브 타이틀 정보 텍트스 값 입니다.
 * 
 */


type InfoBannerProps = {
    title: string;
    pointText: string;
    subtitle: string;
    spacing?: string
    image?: string;
}


const InfoBanner = ({title, pointText, subtitle, spacing, image } : InfoBannerProps) => {
    const [currentSubtitle, setCurrentSubtitle] = useState(subtitle);
    const [isExiting, setIsExiting] = useState(false);

    return (
    <div className="info-banner-animation-container container grid grid-cols-1 desktop:grid-cols-2 gap-12 tablet:gap-20 laptop:gap-24 desktop:gap-32  items-center max-w-screen-desktop mx-auto px-8 w-full" >
        <motion.div
            initial= {{ opacity : 0, y: 30}}
            whileInView={{ opacity: 1, y: 0}}
            viewport={{ once: true, amount: 0.3}}
            transition={{duration: 0.6, ease: 'easeOut'}}
            className='brandinfo-banner-container-text self-start'
        >
        <div className="info-banner-container-main">
            <div className="info-banner-container-title text-left w-fit font-sans">
                <h3 className="info-banner-title mt-4 mb-4 text-xl tablet:text-3xl desktop:text-5xl laptop:text-4xl font-bold leading-tight text-black whitespace-pre-line">
                {title}
                <span className="text-emerald-300">{pointText}</span>
                </h3>
                <p className={`info-banner-subtitle mt-6 text-base tablet:text-2xl desktop:text-2xl laptop:text-2xl text-gray-500 text-pretty whitespace-pre-line font-light ${isExiting ? 'animate-fade-out-up' : ''}`}
            onAnimationEnd={() => {
                if (isExiting) {
                setCurrentSubtitle(subtitle);
                setIsExiting(false);
                }
            }}>
                {currentSubtitle}
                </p>
            </div>  
        </div>    
        </motion.div>
            <motion.div
            initial = {{opacity: 0, y: 30}}
            whileInView={{opacity: 1, y: 0}}
            viewport={{once : true, amount: 0.3}}
            transition={{duration: 0.8, delay: 0.4, ease: 'easeOut'}}
            className='brandinfo-banner-container-image'
            >
            <div className="info-banner-container-img">
                <img src={image} className=" [filter:drop-shadow(0_20px_15px_rgba(16,185,129,0.1))]
                    max-w-full w-[300px] h-[300px] tablet:w-[400px] tablet:h-[400px]  desktop:h-auto"/>
            </div>
        </motion.div>
    </div>
    );
};

export default InfoBanner